import script from "./SogAppBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogAppBar.vue?vue&type=script&setup=true&lang=ts"

import "./SogAppBar.vue?vue&type=style&index=0&id=68355d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68355d06"]])

export default __exports__